export default "__VITE_ASSET__16232a38__"